import { escapeRegExp } from '@sbt-web/utils';
import type { ListFilter } from '@sbt-web/network/types';
import type { FiltersStore } from '@tools/search/getFiltersStore';

export type DependenciesValues = {
  [key: string]: string;
};

export function isDependenciesFilled(
  dependencies: string[] | undefined,
  dependenciesValues: DependenciesValues | undefined
): boolean {
  // If no dependencies are provided, consider them all filled
  return dependencies?.every((dep) => !!dependenciesValues?.[dep]) ?? true;
}

export function buildDataSource(
  baseDataSource: string,
  dependencies?: string[],
  dependenciesValues?: DependenciesValues,
  dependenciesFilled?: boolean | undefined
): string {
  const hasNoDependencies = !dependencies || !dependenciesValues;

  if (
    hasNoDependencies ||
    // don't need to replace dataSource if the dependencies are not filled
    !dependenciesFilled
  )
    return baseDataSource;

  return dependencies.reduce(
    (source, depURI) =>
      source.replace(
        new RegExp(`{${escapeRegExp(depURI)}}`),
        dependenciesValues[depURI]
      ),
    baseDataSource
  );
}

export function extractDependencyValues(
  filter: ListFilter,
  filterStore: FiltersStore,
  activeFilters: { [key: string]: string }
): DependenciesValues | undefined {
  return filter.dependencies?.reduce((values, filterURI) => {
    const dependentFilter = filterStore.findByFilterURI(filterURI);
    if (!dependentFilter) return values;

    return {
      ...values,
      [filterURI]: activeFilters[dependentFilter.queryString],
    };
  }, {});
}
